import router from './router';
import store from './store';
import { hasLogined, isTwicePwded, isInGame } from './utils';
import { repeatCertify, getMyMaps, getMyActs, getActWhiteState } from '@/api/common';
// $vi18n('$i1# 进度条 #i18n$')
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
NProgress.configure({ showSpinner: false });
/*function isTwicePwded() {
  const token = sessionStorage.getItem('token2')
  //console.log('****'+token)
  if(token)  return true
  return false
}   */
// $vi18n('$in# 开关 #i18n$')
let hasAddedRoutes = false;
let getMapsIng = false;
let getActsIng = false;
let hasInited = false;
router.beforeEach(async (to, from, next) => {
  NProgress.start();
  const isToLogin = to.path === '/login';
  const isToCertify = to.name === 'Certify';
  if (hasLogined()) {
    //debugger
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo') || '{}');
    const developerInfo = JSON.parse(sessionStorage.getItem('developerInfo') || '{}');
    window.MiniService.UserService.init(isInGame ? 1 : 2, userInfo);
    let data = { uin: userInfo.uin };
    // 开发者加白状态
    if (developerInfo.state === 3 && to.path !== '/register') {
      next({ path: '/register' });
      return
    }
    // 非开发者
    if (developerInfo.state === 0 && to.path !== '/login') {
      // 新增，state=0的时候，dev_state=1新用户（不能登录），dev_state=2见习开发者（正常登录），dev_state=3转正开发者（已答题开发者，跳转到注册页面）
      if (developerInfo.dev_state === 1) {
        if (to.path !== '/userTransferPage') {
          next({ path: '/userTransferPage' })
          NProgress.done();
          return
        }
      } else if (developerInfo.dev_state === 2) {
        // pass // 正常往下走流程
      } else if (developerInfo.dev_state === 3) {
        if (to.path !== '/register') {
          next({ path: '/register' })
          NProgress.done();
          return
        }
      }
    }
    if (to.path === '/register' && (developerInfo.state !== 3 && developerInfo.dev_state !== 3)) {
      next({ path: '/' })
      NProgress.done();
      return
    }
    if (isToLogin) {
      
      if (isTwicePwded()) {
        next({ path: '/' });
      } else {
        if (isToCertify) {
          next({ path: '/' });
        } else {
          let res = await repeatCertify(data);
          // console.log('---' + res.code);
          if (res.code === 500) {
            next({ name: 'Certify', params: { uin: userInfo.uin } });
          } else {
            next({ path: '/' });
          }
        }
        //  isToCertify ? next() : next({ name: 'Certify', params: { uin: userInfo.uin }})
      }
    } else {
      if (!hasAddedRoutes) {
        hasAddedRoutes = true;
        await store.dispatch('addAsyncRoutes');
        if (isTwicePwded()) {
          next({ ...to });
        } else {
          //    isToCertify ? next({...to}) : next({ name: 'Certify', params: { uin: userInfo.uin }})
          if (isToCertify) {
            next({ ...to });
          } else {
            let res = await repeatCertify(data);
            //   console.log('***'+res.code)
            if (res.code === 500) {
              next({ name: 'Certify', params: { uin: userInfo.uin } });
            } else {
              //  debugger
              next({ ...to });
            }
          }
        }
        // router.push({ ...to }); // $vi18n('$in# 修复控制台报 #i18n$') ”Redirected when going from "/login" to "/home" via a navigation guard.“ $vi18n('$in# 问题 #i18n$')
      } else {
        if (isTwicePwded()) {
          next();
        } else {
          //  isToCertify ? next() : next({ name: 'Certify', params: { uin: userInfo.uin }})
          if (isToCertify) {
            next();
          } else {
            let res = await repeatCertify(data);
            //  console.log('+++'+res.code)
            if (res.code === 500) {
              next({ name: 'Certify', params: { uin: userInfo.uin } });
            } else {
              next();
            }
          }
        }
      }
    }
    NProgress.done();
  } else {
    // $vi18n('$i1# 未登录的情况 #i18n$')，$vi18n('$i18n# 允许访问登录页 #i18n$')，
    if (isToLogin) {
      next();
    } else {
      next({ path: '/login' });
    }
    NProgress.done();

    // $vi18n('$i1# 退出时重置开关 #i18n$')
    hasAddedRoutes = false;
  }
});

router.afterEach(() => {
  NProgress.done();
});
